//@flow

import {Chip, makeStyles} from '@material-ui/core';
import React from 'react';
import type {ChipProps} from '@material-ui/core';
import {classNames} from '../../utils/react';
import {colors} from '../../assets/styles/colors';

type Props = {
  color:
    | 'primary'
    | 'secondary'
    | 'default'
    | 'success'
    | 'warning'
    | 'danger'
    | 'info',
} & ChipProps;

const useStyles = makeStyles(theme => ({
  chipPrimary: {
    background: `${colors.primary}1a`,
    fontWeight: 600,
    color: colors.primary,
    '& span': {
      fontSize: '11px!important',
      color: colors.primary,
    },
  },

  chipSecondary: {
    background: `${colors.secondary}1a`,
    fontWeight: 600,
    '& span': {
      fontSize: '11px!important',
      color: colors.secondary,
    },
  },

  chipDefault: {
    background: `${colors.grey500}1a`,
    fontWeight: 600,
    '& span': {
      fontSize: '11px!important',
      color: colors.grey500,
    },
  },

  chipSuccess: {
    background: `${colors.success}1a`,
    fontWeight: 600,
    '& span': {
      fontSize: '11px!important',
      color: colors.success,
    },
  },

  chipWarning: {
    background: `${colors.warning}40`,
    fontWeight: 600,
    '& span': {
      fontSize: '11px!important',
      color: colors.grey800,
    },
  },

  chipDanger: {
    background: `${colors.danger}1a`,
    fontWeight: 600,
    '& span': {
      fontSize: '11px!important',
      color: colors.danger,
    },
  },

  chipInfo: {
    background: `${colors.info}1a`,
    fontWeight: 600,
    '& span': {
      fontSize: '11px!important',
      color: colors.info,
    },
  },
  chipBase: {
    cursor: 'inherit',

    '& .MuiChip-label': {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
}));

export default function CustomChip(props: Props) {
  const {color = 'primary', ...chipProps} = props;
  const classes = useStyles();

  const chipClasses = classNames(classes.chipBase, {
    [classes.chipPrimary]: color === 'primary',
    [classes.chipSecondary]: color === 'secondary',
    [classes.chipDefault]: color === 'default',
    [classes.chipSuccess]: color === 'success',
    [classes.chipWarning]: color === 'warning',
    [classes.chipDanger]: color === 'danger',
    [classes.chipInfo]: color === 'info',
  });

  return <Chip className={chipClasses} {...chipProps} />;
}
